import type { HeadingProps } from '../Heading/index.ts';
import type { VanillaLinkProps } from '../Link/index.ts';
import clsx from 'clsx';
import { PiArrowLeftBold } from 'react-icons/pi';
import { FormattedMessage } from 'react-intl';
import { Heading } from '../Heading/index.ts';
import { Text } from '../Text/index.ts';

export function PageHeader({
  actions,
  backLabel,
  heading,
  headingLevel = 1,
  leftElement,
  renderBackLink,
  summary
}: {
  actions?: React.ReactNode;
  backLabel?: React.ReactNode;
  heading: React.ReactNode;
  headingLevel?: HeadingProps['level'];
  leftElement?: React.ReactNode;
  renderBackLink?: (props: VanillaLinkProps) => React.ReactNode;
  summary?: React.ReactNode;
}) {
  return (
    <header className="@container mb-8">
      {!!renderBackLink && (
        <div className="mb-4">
          {renderBackLink({
            children: (
              <Text className="inline-flex items-center" subdued>
                <PiArrowLeftBold className="mr-1 -ml-0.5 size-4" />
                <span>
                  {backLabel || <FormattedMessage id="ui:nav.go-back" defaultMessage="Go back" />}
                </span>
              </Text>
            ),
            plain: true
          })}
        </div>
      )}

      <div
        className={clsx(
          'cq-no-support:md:flex cq-no-support:md:grow cq-no-support:md:items-center cq-no-support:md:justify-between cq-no-support:md:gap-x-5',
          '@xl:flex @xl:grow @xl:items-start @xl:justify-between @xl:gap-x-5'
        )}
      >
        <div className="flex min-w-0 grow items-center">
          {!!leftElement && (
            <div className={clsx('mr-4', headingLevel === 1 || !!summary ? 'h-16' : 'h-12')}>
              {leftElement}
            </div>
          )}

          <div className="max-w-full">
            <Heading
              className={clsx('wrap-break-word', !!summary && 'mt-0.5')}
              level={headingLevel}
            >
              {heading}
            </Heading>

            {summary && (
              <div className={clsx('mt-0.5 text-gray-500', headingLevel === 1 && 'mt-1')}>
                {summary}
              </div>
            )}
          </div>
        </div>

        {actions && (
          <div
            className={clsx(
              'mt-6 flex flex-col-reverse justify-stretch gap-y-4',
              'cq-no-support:sm:flex-row-reverse cq-no-support:sm:justify-end cq-no-support:sm:gap-x-3 cq-no-support:sm:gap-y-0',
              'cq-no-support:md:mt-0 cq-no-support:md:flex-row cq-no-support:md:gap-x-3',
              '@md:flex-row-reverse @md:justify-end @md:gap-x-3 @md:gap-y-0 @xl:mt-0 @xl:flex-row @xl:gap-x-3'
            )}
          >
            {actions}
          </div>
        )}
      </div>
    </header>
  );
}
